export default __webpack_public_path__ + "static/media/misc-pantry3-1440w.cd603203.avif";